import { createContext } from 'react';
import { DEFAULT_CONFIG } from '../../model/config/default';
/**
 * @internal Intended for internal use - use it on your own risk
 */
export var ConfigContext = createContext({
  config: DEFAULT_CONFIG,
  updateConfig: function updateConfig() {
    return undefined;
  }
});